"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("react");
var FormControlContext = (0, react_1.createContext)({});
FormControlContext.displayName = 'PrezzeeFormControlContext';
exports.default = FormControlContext;
//# sourceMappingURL=FormControlContext.js.map